import { createContext, useContext, useState, useCallback } from "react";
import api from "../api/client";

const AUTH_KEY = "auth_token";
const AuthContext = createContext({ authenticated: false });

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(() => !!localStorage.getItem(AUTH_KEY));

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem(AUTH_KEY);
    setAuthenticated(false);
  }, []);

  const clearAuth = useCallback(() => {
    localStorage.removeItem(AUTH_KEY);
    setAuthenticated(false);
  }, []);

  return (
    <AuthContext.Provider value={{ authenticated, logout, clearAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
